import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, Link as RouterLink } from 'react-router-dom';
import { Paper, Typography, CircularProgress, Link } from '@mui/material';
import { onboardingApi, setSession } from '../api';

// The private continue link (open link): a fresh 7-day session, then the wizard (or the status page once submitted), under
// whatever brand the application has now — the team may have assigned one since.
export default function ContinuePage() {
  const { token } = useParams(); const navigate = useNavigate(); const [dead, setDead] = useState(false);
  useEffect(() => {
    onboardingApi.open.continueWith(token).then(r => {
      setSession(r.sessionToken, r.brandSlug, { persist: true });
      navigate(['draft', 'changes_requested'].includes(r.status) ? `/${r.brandSlug}/onboarding/app` : `/${r.brandSlug}/onboarding/status`, { replace: true });
    }).catch(() => setDead(true));
  }, [token, navigate]);
  if (!dead) return <CircularProgress />;
  return (<Paper sx={{ p: { xs: 3, sm: 4 } }}>
    <Typography variant="h6" gutterBottom>This link is no longer valid.</Typography>
    <Typography>A newer link may have been sent. Use <Link component={RouterLink} to="/apply">Email me my link</Link> to get a fresh one.</Typography>
  </Paper>);
}
